import { joinPath } from '@eventbrite/path-utils';
import { BASE_URL, PICK_A_SEAT_PATH } from '../../../constants';
import { push } from 'react-router-redux';
import { processOrder } from './processOrder';
import { BEST_AVAILABLE_NOT_FOUND_ERROR } from '../../../api/constants';
import { SET_PICK_A_SEAT_BEST_AVAILABLE_WARNING } from '../constants';
import { handleOnCreateOrderError } from './handleOnCreateOrderError';
import { getAttendees, getIsTransferredOrder } from '../../../selectors/order';
import { getPathAfterTicketSelection } from './getPathAfterTicketSelection';
import { CheckoutErrorName } from '@eventbrite/checkout-postmessage-api';
import { notifyParentOrderCreationError } from '../../notifyParent';
import get from 'lodash/get';
import { refreshEventAndTickets as refreshEventAndTicketsAction } from '../../initialize';
import { shouldAbortOrderCreationAndRedirectToCaptchaError } from './shouldAbortOrderCreationAndRedirectToCaptchaError';

export const setPickASeatBestAvailableWarning = (message) => ({
    type: SET_PICK_A_SEAT_BEST_AVAILABLE_WARNING,
    payload: message,
});

export const createPickASeatOrder = () => async (dispatch, getState) => {
    try {
        if (
            await shouldAbortOrderCreationAndRedirectToCaptchaError(
                dispatch,
                getState(),
            )
        ) {
            return;
        }

        await processOrder(dispatch, getState);
        return dispatch(push(joinPath(BASE_URL, PICK_A_SEAT_PATH)));
    } catch (customSubmissionError) {
        /**
         * When "ERROR_NO_MATCH_FOUND" inventory error raised after clicking "Buy on Map"
         * Clear the selected tickets and go to pick a seat with emtpy order.
         * Set warning state so that an warning notification would be displayed in pick a seat view.
         */
        if (
            get(customSubmissionError, 'errors._error') ===
            BEST_AVAILABLE_NOT_FOUND_ERROR
        ) {
            await dispatch(
                refreshEventAndTicketsAction(null, customSubmissionError),
            );
            await dispatch(
                setPickASeatBestAvailableWarning(
                    BEST_AVAILABLE_NOT_FOUND_ERROR,
                ),
            );

            return dispatch(createPickASeatOrder());
        }

        return handleOnCreateOrderError(dispatch)(customSubmissionError);
    }
};

export const createOrder =
    ({ shouldRedirect }) =>
    async (dispatch, getState) => {
        try {
            await processOrder(dispatch, getState);

            if (!shouldRedirect) {
                return;
            }

            const state = getState();
            const {
                event: { isReservedSeating },
            } = state;
            const shouldShowReservedTicketsFlow =
                isReservedSeating && !getIsTransferredOrder(state);
            const attendees = getAttendees(state);

            return dispatch(
                push(
                    getPathAfterTicketSelection({
                        shouldShowReservedTicketsFlow,
                        attendees,
                    }),
                ),
            );
        } catch (error) {
            let errorCode;
            try {
                errorCode = JSON.parse(error?.extraData?.parsedError)?.error;
            } catch {
                errorCode = CheckoutErrorName.GENERIC_ERROR;
            }

            dispatch(notifyParentOrderCreationError(errorCode));

            return handleOnCreateOrderError(dispatch)(error);
        }
    };
